import React , {useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {  Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import { useTheme } from '@mui/material/styles';
import {Avatar, Paper, Menu, MenuItem, Fab, Grid, Divider, Typography, List, ListItem, ListItemIcon, ListItemText} from '@mui/material';
import TexField from '@mui/material/TextField';
import GridItem from "../../components/Grid/GridItem";
import GridContainer from "../../components/Grid/GridContainer";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Button from "../../components/CustomButtons/Button";
import SendIcon from '@mui/icons-material/Send';
import MenuIcon from '@mui/icons-material/Menu';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CancelIcon from '@mui/icons-material/Cancel';
import Video from '../../components/VideoPlayer/Video';
import CardHeader from "../../components/Card/CardHeader";
//import { Document, Page } from 'react-pdf';
import {mongoUrl} from '../shared/mongoUrl.js';
import {useSelector, useDispatch} from 'react-redux';
import {baseUrl} from '../shared/baseUrl';


const styles = (theme) => ({
  table: {
    minWidth: 650,
  },
  chatSection: {
    width: '100%',
    height: '50vh',
    backgroundColor: '#e0e0e0'
  },
  headBG: {
      backgroundColor: '#ffffff',
      textAlign: 'right'
  },
  borderRight500: {
      borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    height: '40vh',
    overflowY: 'auto'
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    align: "center"
  }
});




function Support(props){
  const theme = useTheme()
  const classes = styles(theme);
  var interval = null
  const [file, setfile] = React.useState(null);
  const [currentfile, setcurrentfile] = React.useState('');
  const [url, seturl] = React.useState('');
  const [username, setusername] = React.useState('');
  const [mydata, setmydata] = React.useState('');
  const [profileid, setprofileid] = React.useState('');
  const [active, setactive] = React.useState('');
  const [msg, setmsg] = React.useState('');
  const [filemsg, setfilemsg] = React.useState('');
  const [replymsg, setreplymsg] = React.useState('');
  const [chat, setchat] = React.useState([]);
  const [loading, setloading] = React.useState(true);
  const [cbutton, setcbutton] = React.useState(true);
  const [rbutton, setrbutton] = React.useState(true);
  const [img, setimg] = React.useState(false);
  const [pdf, setpdf] = React.useState(false);
  const [vid, setvid] = React.useState(false);
  const messageEl = useRef(null);
  const [Openreply, setOpenreply] = React.useState('');
  const [curruser, setcurruser] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const user = useSelector(state => state.user);
  const [currteacher, setcurrteacher] = React.useState([]);



const handleClick = (id) => {
    console.log(id)
    setOpenreply(id);
  }; 


  useEffect(() =>{
     // console.log(messageEl)
    if (messageEl) {
        
        messageEl.current.addEventListener('DOMNodeInserted', event => {

            let tar = false;

            if(event.target.nodeName == 'SPAN' || event.target.nodeName == 'BUTTON'){
                tar = true
               
            }

            if(tar==false ){
            const { currentTarget: target } = event;
            target.scroll({ top: target.scrollHeight, behavior: 'smooth' });
            }
       
        });




      }
  }, [])

  //console.log(Count)

  useEffect(() => {  

      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const loadData=()=>{
      const act = props.act;
      const profileid = props.user;
      var type='student'
      if(typeof(props.type)!='undefined'){
          type=props.type
      }
      setcurruser(type)
      console.log(profileid)
      setactive(act);
      setprofileid(profileid)

      try{
        axios.get(`${baseUrl}pyinterpreter/profile/${profileid}`,config, { cancelToken: source.token })
        .then((response) =>{   
            if(type=='student'){
                console.log('student updated')
              response.data.lastViewStudentSupport=new Date()
            }
            else{
              console.log('teacher updated')
              response.data.lastViewSupport=new Date()
            }

            const mdata=
            {
              profile: response.data
            }                     
            //console.log(mdata)
      
            axios.put(`${baseUrl}pyinterpreter/profile/save/${profileid}`, mdata)
            .then((response) => {
              //console.log(response.data)
              setmydata(response.data)
              getTeacher(props.classid)
              getData(profileid)
              console.log('I am in support')
      
              interval = setInterval(() => {
                  //console.log('Interval is working')
                  getData(profileid);
              }, 5000);
            })
          })
      
  } catch (error) {
      if (axios.isCancel(error)) {
        console.log("cancelled");
      } else {
        throw error;
      }
    }

    interval = setInterval(() => {
       // console.log('Interval is working')
        getData(profileid);
    }, 5000);

  };

  loadData();

  return() => {source.cancel();
  };


  }, []);


  useEffect(() => {  
    clearInterval(interval);

   })

   const getTeacher = (classid) =>{
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
    axios.get(`${baseUrl}class/${classid}`, { cancelToken: source.token })
    .then((response) => {
      const dat = Array.from(response.data)
      const teacherId=response.data.teacherId
      axios.get(`${baseUrl}users/${teacherId}`,config, { cancelToken: source.token })
      .then((res) => {
        //console.log(res.data)
        var tname = res.data.fname+' '+res.data.lname;
        var teach = [];
        teach.push({
            Name:tname
        })
        if(response.data.coTeachers=='[]'){
            response.data.coTeachers.map((text)=>{
                teach.push({
                    Name:text.Email
                })
            })
        }

        console.log(teach)
        setcurrteacher(teach)
        axios.get(`${baseUrl}users/${user.id}`,config, { cancelToken: source.token })
      .then((res) => {
        var tname = res.data.fname+' '+res.data.lname;
        setusername(tname)
        console.log(tname)
        })
      })
    //setclasse(dat)
    //setloading(false)
    //props.mod=response.data;

    })
   }

   const getData = (userid) =>{
    
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    
    axios.get(`${baseUrl}pyinterpreter/profile/${userid}/support`, { cancelToken: source.token })
      .then((response) => { 
      setchat(response.data)
      //console.log(response.data)
      setloading(false)
      })
}
//console.log(chat);
const previewStyle = {
    maxHeight: "300px",
    maxWidth: "200px"
  }


const ReplyCancel = () => {
    setOpenreply('')
  };

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function handleReplyMsg(event){
    console.log(event.target.value)

    if(event.target.value){
        setrbutton(false)
       setreplymsg(event.target.value);
          
    }
    else{
        setreplymsg('');
        setrbutton(true)

        

    }
   } 

   function ReplyChat(msg,name){
    const mymsg = 'Replying to " '+msg.slice(0,10) +'" '+replymsg
    console.log(mymsg)

    const data=new FormData();

    data.append('user', user.id)
    data.append('name',username)
    data.append('activity', props.act)
    data.append('created', new Date())
    data.append('message', mymsg)
    //data.append('file', currentfile)   
    let url = `${baseUrl}pyinterpreter/profile/${profileid}/support`;
    console.log(data)

    axios.post(url, data)
    .then(res => {
        setchat(res.data)
        setcurrentfile('')
        
        console.log(res)
    })
    .catch(errors => console.log(errors));

}



const RenderSendChat=(cht)=>{
 
     return(
     <GridContainer className={classes.headBG}> 
        <GridItem xs={12} sm={12} md={12}>
            <ListItem>
                <ListItemText align="right" primary={cht.message}></ListItemText> 
                {typeof cht.message==='undefined'?cht.message='':null}
            </ListItem>
             {typeof cht.image!=='undefined'?
             <Link to= {{ pathname: mongoUrl+cht.image }} target="_blank">
                <ListItem>
                 <img src={mongoUrl + cht.image} style={previewStyle} />
                </ListItem>
            </Link>:null}
            {typeof cht.pdf!=='undefined'?
            <Link to= {{ pathname: mongoUrl+cht.pdf }} target="_blank">
              <ListItem>
                  <img src={`${baseUrl}assets/images/pdficon.png`} style={previewStyle} />
              </ListItem>
              </Link>
              :null}
            {typeof cht.video!=='undefined'?
            <ListItem>
                <Video url = {mongoUrl + cht.video}
                    width="200px" height="200px"/>
            </ListItem>
            :null}
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
            <ListItem>
                <ListItemText align="right" secondary={new Date(cht.created).toLocaleTimeString()}></ListItemText>
            </ListItem>
        </GridItem>
     </GridContainer>
     );
}

const RenderReceiveChat=(cht)=>{
    // const classe = useStyles();
 
     return(
    <GridContainer className={classes.headBG}>
        <GridItem xs={12} sm={12} md={12}>
            <ListItem button key={cht.usergroup}>
                <ListItemIcon>
                    <Avatar alt={cht.usergroup} src={`${baseUrl}assets/images/avatar.png`} />
                </ListItemIcon>
                {curruser=='student'?<ListItemText>Teacher</ListItemText>
                :<ListItemText>Student</ListItemText>}
            </ListItem>
            <ListItem>
                <ListItemText align="left" primary={cht.message}></ListItemText>
                {typeof cht.message==='undefined'?cht.message='':null}
            </ListItem>
            {typeof cht.image!=='undefined'?
            <Link to= {{ pathname: mongoUrl+cht.image }} target="_blank">
            <ListItem button>
                <img src={mongoUrl + cht.image} style={previewStyle} />
            </ListItem></Link>:null}
            {typeof cht.pdf!=='undefined'?
            <Link to= {{ pathname: mongoUrl+cht.pdf }} target="_blank">
                <ListItem>
                    <img src={`${baseUrl}assets/images/pdficon.png`} style={previewStyle} />
                </ListItem>
            </Link>
            :null}

            {typeof cht.video!=='undefined'?
            <ListItem>
                <Video url = {mongoUrl + cht.video}
                    width="300px" height="200px"/>
            </ListItem>:null}
            <ListItem>

                {/* {console.log(Openreply)} */}

            {Openreply!==cht._id?
            
            <Button color="transparent" variant="contained" size="sm" onClick={ e => handleClick(cht._id)} > Reply</Button>
             : 
             <span>
                <TexField 
                        value={replymsg}
                        type="text"
                        label="Write something"
                        name="message"
                        fullWidth= {true} 
                        onChange={handleReplyMsg}
                    /> 
                    <Fab color="primary" aria-label="add" size="small" disabled={rbutton}
                    onClick={e => ReplyChat(cht.message,cht.usergroup)}>
                    <SendIcon /></Fab> 
                    <Fab color="primary" aria-label="add" size="small" onClick={ReplyCancel}>
                        <CancelIcon />
                    </Fab></span> 
                 } 
            </ListItem>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
            <ListItemText align="left" secondary={new Date(cht.created).toLocaleTimeString()}></ListItemText>
        </GridItem>
    </GridContainer>
    
     );
}




const Chatlist = chat.map((cht) => {
    //console.log(cht)
    if(cht.activity==props.act){
    return(
        // <div>
            <div key={cht._id}style={{ overflowX: 'hidden' }}>
                {cht.user!==user.id? 
                    RenderReceiveChat(cht) : 
                    RenderSendChat(cht)}
                    <Divider />
            </div>

        // </div>
        );
    }
})




const handleButtonClick = (event) => {

    setfile(event.currentTarget)
    
  };
  
 const handleClose = () => {
    setfile(null)
  };
  const CancelButton = () => {
    setcurrentfile('')
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

const handleUploadImage=(event) => {
    event.preventDefault();
    let reader = new FileReader();
    let file = event.target.files[0];
    setcurrentfile(event.target.files[0]);
    //seturl(URL.createObjectURL(event.target.files[0]));
    var url = reader.readAsDataURL(file)

    reader.onloadend = () => {

        seturl(reader.result)
      }
  
   
    setimg(true)
    setpdf(false)  
    setvid(false)  
  
    handleClose();
};
const handleUploadPdf=(event) => {
    event.preventDefault();
    
    setcurrentfile(event.target.files[0]);
    seturl(URL.createObjectURL(event.target.files[0]));
    setpdf(true) 
    setimg(false)  
    setvid(false)   
    handleClose();
};

const handleUploadVideo=(event) => {
    setcurrentfile(event.target.files[0]);
    seturl(URL.createObjectURL(event.target.files[0]));
    setvid(true)
    setpdf(false); 
    setimg(false);  
    handleClose();
};

   
function handleFileMsg(event){
    console.log(event.target.value)

    if(event.target.value){
       setfilemsg(event.target.value);
          
    }
    else{
        setfilemsg('');
        

    }
   } 

  
   
  function handleMsg(event){

    if(event.target.value){
       setmsg(event.target.value);
       setcbutton(false);
    }
    else{
        setmsg('');
        setcbutton(true);

    }
   }   
  
   
function uploadFile(){
    const data=new FormData();
    
    //// imageFile is set as single key in backend 
    data.append('user', user.id)
    data.append('name',username)
    data.append('activity', props.act)
    data.append('created', new Date())
    data.append('message', filemsg)
    data.append('file', currentfile)   
    let url = `${baseUrl}pyinterpreter/profile/${profileid}/support`;
    console.log(data)

    axios.post(url, data)
    .then(res => {
        setchat(res.data)
        setcurrentfile('')
        
        // console.log(res)
    })
    .catch(errors => console.log(errors));

}

// console.log(grouplistid)
  return (
      <div>
        <GridContainer>
            <GridItem xs={12} sm={12} md={12} component={Paper} className={classes.chatSection} >
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CardHeader color="rose" align="center">
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={2}>
                                    <Fab 
                                    aria-controls="simple-menu" 
                                    color="primary"
                                    size="small" 
                                    aria-haspopup="true" 
                                    onClick={handleClickMenu}>
                                        <MenuIcon/>
                                    </Fab>
                                    {loading!==true?
                                        <Menu
                                            id="simple-menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleCloseMenu}
                                        >
                                            <MenuItem align='center'>Teachers</MenuItem>
                                            <Divider />
                                            {currteacher.map((text, index) => (
                                                <MenuItem key={index}>
                                                    <FiberManualRecordIcon color="primary"/>
                                                    {text.Name}
                                                </MenuItem>
                                            ))}
                                            
                                        </Menu>:null}
                                </GridItem>
                                <GridItem xs={12} sm={12} md={10}>
                                    <Typography variant="subtitle1" align="center" className={classes.cardTitleWhite}>Support {props.act}</Typography>
                                </GridItem>
                            </GridContainer>
                        </CardHeader>
                    </GridItem>
                </GridContainer>
                    <List className={classes.messageArea} ref={messageEl}>
                        {Chatlist}
                    </List>
                    {/* {console.log(url)} */}
                {currentfile!==''?
                <div>
                    <p>Preview file</p>
                    {img===true?
                    <img src={url} style={previewStyle} />:null}
                    {pdf===true?
                    <iframe src={url}
                    width="300px" height="400px" ></iframe>:null}
                    {vid===true?
                    <Video url = {url}
                    width="300px" height="200px"/>
                    :null}

                    <TexField
                        
                        value={filemsg}
                        type="text"
                        label="Write something"
                        name="message"
                        ///validate={this.validateTitle}
                        fullWidth= {true} 
                        onChange={handleFileMsg}
                    /> 
                    <Fab color="primary" aria-label="add" size="small"
                    onClick={uploadFile}
                    >
                    <SendIcon /></Fab> 
                    <Fab color="primary" aria-label="add" size="small" onClick={CancelButton}>
                        <CancelIcon />
                    </Fab></div>:null}
                
                 {/* <Divider /> */}
                {currentfile===''?

                 <Formik
                    initialValues={{
                        message:'',
                        dateTime: new Date()
                     }}

                    //validationSchema={validationSchema}

                    onSubmit={(values, {setSubmitting}) => {
                    setTimeout(() => {


                        setSubmitting(false);
                        
                     // alert(JSON.stringify(values, null, 2));

                        const chatbody = {
                            user:user.id,
                            activity:props.act,
                            name:username,
                            message: msg,
                            created:values.dateTime,
                        }
                        //console.log(chatbody);
                        setmsg('')
                        setcbutton(true);
                        // console.log(grouplistid)
                        axios.post(`${baseUrl}pyinterpreter/profile/${profileid}/support`, chatbody)
                        .then(res => 
                            {
                                setchat(res.data)
                                console.log(res.data)
                            });

                    }, 500);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors}) => (
                        <Form>
                            <Grid container style={{padding: '5px'}}>
                                <Grid item xs={8}>

                                    <Field
                                        component={TextField}
                                        value={msg}
                                        type="text"
                                        label="Type something"
                                        name="message"
                                        ///validate={this.validateTitle}
                                        fullWidth= {true} 
                                        onChange={handleMsg}
                                        />                                
                                </Grid>
                                <Grid item xs={2} align="right">
                                    <Fab color="primary" aria-label="add" disabled={!isSubmitting && cbutton} size="small"

                                    onClick={submitForm}><SendIcon /></Fab>
                            
                                </Grid>
                                <Grid item xs={2} align="right">
                                    
                                        <Fab color="primary" aria-label="add" disabled={isSubmitting} size="small" 
                                        area-haspopup="true" onClick={e =>handleButtonClick(e)}
                                        ><AttachFileIcon /></Fab>
                                        <Menu
                                            elevation={0}
                                            getContentAnchorEl={null}
                                            anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                            }}
                                            transformOrigin={{ vertical: "top", horizontal: "center" }}
                                            id="simple-menu"
                                            anchorEl={file}
                                            keepMounted
                                            open={Boolean(file)}
                                            onClose={handleClose}>


                                            <MenuItem>
                                                
                                                <label htmlFor="upload-image">
                                                    <input
                                                    accept="image/*"
                                                    style={{ display: "none" }}
                                                    id="upload-image"
                                                    name="upload-image"
                                                    type="file"
                                                    onChange={e => handleUploadImage(e)}
                                                    />
                                                <Fab color="secondary" aria-label="add" size="small"component="span"
                                                >
                                                    <InsertPhotoIcon /> 
                                                </Fab>
                                                </label>

                                            </MenuItem>
                                            <MenuItem>
                                                <label htmlFor="upload-pdf">
                                                    <input
                                                    accept="application/pdf"
                                                    style={{ display: "none" }}
                                                    id="upload-pdf"
                                                    name="upload-pdf"
                                                    type="file"
                                                    onChange={handleUploadPdf}
                                                    />
                                                <Fab color="secondary" aria-label="add" size="small" component="span">
                                                    <PictureAsPdfIcon /> 
                                                </Fab>
                                                </label>
                                            </MenuItem>
                                            <MenuItem>
                                                <label htmlFor="upload-video">
                                                    <input
                                                    accept="video/*"
                                                    style={{ display: "none" }}
                                                    id="upload-video"
                                                    name="upload-video"
                                                    type="file"
                                                    onChange={handleUploadVideo}
                                                    />
                                                <Fab color="secondary" aria-label="add" size="small" component="span">
                                                    <VideoLibraryIcon /> 
                                                </Fab>
                                                </label>
                                            </MenuItem>                
                   
                                        </Menu>

                                </Grid>
                            </Grid>
                    </Form>)}
                </Formik>:null}
            </GridItem>
        </GridContainer>

      </div>
  );
}

export default Support;